export const URLs = {
  learnosityAPI: 'https://items.learnosity.com/?v2025.2.LTS',
  loadInitialTestlet: '/api/MWS.ALS/ALS/LoadInitialTestlet',
  verifyAndLoadNextTestlet: '/api/MWS.ALS/ALS/VerifyAndLoadNextTestlet',
  getAssessmentStep: '/api/MWS.ALS/AssessmentStep/GetAssessmentStep',
};
